import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useItemByIdQuery, useItemTagsQuery, useItemUpdateMutation } from 'api';
import { FormInstance, FormProps } from 'components';
import { ItemAddFormFieldType } from 'pages/admin/items/addItem';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { getUpdatedPayload } from 'utils/helpers';

interface ItemEditFormFieldType extends ItemAddFormFieldType {
  id: string;
  manualTags: object[];
}

export const useItemDetailsEdit = (props: { form: FormInstance } & any) => {
  const { onCancel, form, open } = props;
  const { handleSuccess, handleError } = useNotificationMessages();
  const { id } = useParams() as { id: string };
  const { data: itemDetails = {} } = useItemByIdQuery({ id });
  const { data: tagData = [] } = useItemTagsQuery();
  const [updateItemDetails, { isLoading }] = useItemUpdateMutation();

  const onCancelModal = useCallback(() => {
    form.resetFields();
    onCancel();
  }, [form, onCancel]);

  const onFinish: FormProps<ItemEditFormFieldType>['onFinish'] = useCallback(
    async (values: ItemEditFormFieldType) => {
      const payload = getUpdatedPayload(values, itemDetails);
      payload.id = id;
      try {
        const { data, error }: any = await updateItemDetails(payload);
        if (data?.success) {
          handleSuccess(`Item was successfully updated.`);
          onCancelModal();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [updateItemDetails, onCancelModal, id, handleError, handleSuccess, itemDetails]
  );

  useEffect(() => {
    if (open && itemDetails) {
      form.setFieldsValue({ ...itemDetails, brandId: itemDetails.brandInfo?.id });
    }
  }, [itemDetails, open, form]);
  return {
    onFinish,
    itemDetails,
    tagData,
    onCancelModal,
    isLoading,
  };
};
